import React, { ChangeEvent, Component } from "react";
import "./OwTextArea.scss";
import { injectIntl, useIntl } from "react-intl";
import UIService from "../../../services/UIService";

type Props = {
    className?: string;
    placeholder?: string;
    fn: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    disabled?: boolean;
    value?: any;
    isRequired?: boolean;
    name: string;
    /**
     * The number of rows to show in the textarea
     */
    rows?: number;
    role?: string;
};

const OwTextArea = (props: Props) => {
    const intl = useIntl();

    const onBlur = (e: any) => {
        UIService.iOSKeyboardOpenFix();
    };

    let placeholder = "";

    if (props.placeholder) {
        placeholder = intl.formatMessage({
            id: props.placeholder,
        });
    }

    return (
        <textarea
            role={props.role}
            className={"OwTextArea form-control " + props.className}
            placeholder={placeholder}
            disabled={props.disabled}
            value={props.value || ""}
            onChange={props.fn}
            name={props.name}
            required={props.isRequired}
            onBlur={onBlur}
            rows={props.rows}
        />
    );
};

export default OwTextArea;
